<template>
  <div>
    <!-- begin breadcrumb -->
    <breadcrumb activeName="权限信息" :breadcrumbItem="[{to:'/system/rbac/permission',name:'权限信息'}]"></breadcrumb>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">
      权限信息
      <small>权限信息...</small>
    </h1>
    <!-- end page-header -->
    <panel title="系统角色数据" :noButton="true">
      <div class="demo-split">
        <Split v-model="leftpanel">
          <div slot="left" class="demo-split-pane">
            <Card :bordered="false">
              <p slot="title">权限结构</p>
              <Tree :data="permissionTree" @on-select-change="edit_permission"></Tree>
            </Card>
          </div>
          <div slot="right" class="demo-split-pane">
            <Card :bordered="false">
              <p slot="title">权限信息</p>
              <button type="button" class="btn btn-theme" slot="extra" @click="add_permission">
                <i class="fa fa-plus"></i> 新增权限
              </button>

              <Form :model="formData" ref="userForm" :label-width="100" :rules="rules">
                <Row :gutter="32">
                  <Col span="10">
                    <FormItem label="名称" label-position="top" prop="name">
                      <Input v-model="formData.name" placeholder="请输入名称" />
                    </FormItem>
                  </Col>
                </Row>
                <Row :gutter="32">
                  <Col span="10">
                    <FormItem label="前端Url" label-position="top" prop="fronturl">
                      <Input v-model="formData.fronturl" placeholder="前端路径" />
                    </FormItem>
                  </Col>
                  <Col span="10">
                    <FormItem label="ApiUrl" label-position="top" prop="url">
                      <Input v-model="formData.url" placeholder="请输入Url" />
                    </FormItem>
                  </Col>
                </Row>
                <Row :gutter="32">
                  <Col span="10">
                    <FormItem label="上级菜单" label-position="top">
                      <Treeselect
                        v-model="formData.pid"
                        :multiple="false"
                        :options="permissionTreeSelect"
                      />
                    </FormItem>
                  </Col>
                  <Col span="10">
                    <FormItem label="权限级别" label-position="top" prop="level">
                      <Select v-model="formData.level" @on-change="fn_change_level">
                        <Option value="app" label="应用">应用</Option>
                        <Option value="module" label="模块">模块</Option>
                        <Option value="menu" label="菜单">菜单</Option>
                        <Option value="function" label="功能">功能</Option>
                      </Select>
                    </FormItem>
                  </Col>
                </Row>

                <Row :gutter="32">
                  <Col span="20">
                    <FormItem label="备注" label-position="top">
                      <Input type="textarea" v-model="formData.remarks" placeholder="请输入备注" />
                    </FormItem>
                  </Col>
                </Row>
                <Row :gutter="32">
                  <Divider dashed orientation="left">角色</Divider>
                  <Col span="24">
                    <FormItem label>
                      <CheckboxGroup v-model="roles">
                        <Col span="4" :key="index" v-for="(item,index) in roleList">
                          <Checkbox
                            style="margin-right:10px"
                            :value="item.id"
                            :label="item.id"
                          >{{item.name}}</Checkbox>
                        </Col>
                      </CheckboxGroup>
                    </FormItem>
                  </Col>
                </Row>
                <Divider dashed orientation="left"></Divider>
                <Row :gutter="32">
                  <Col span="24">
                    <FormItem>
                      <button
                        v-if="btn_save"
                        type="button"
                        class="btn btn-theme"
                        @click="fn_save"
                      >保存</button>
                    </FormItem>
                  </Col>
                </Row>
              </Form>
            </Card>
          </div>
        </Split>
      </div>
    </panel>
  </div>
</template>
<script>
import {
  getPermissionTree,
  getPermissionById,
  storePermission
} from "@/api/system/permission";
import { getRoleList } from "@/api/system/role";
import breadcrumb from "@/components/breadcrumb";
// import the component
import Treeselect from "@riophae/vue-treeselect";
// import the styles
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  components: { Treeselect, breadcrumb },
  beforeMount() {
    getPermissionTree()
      .then(res => {
        if (res.status === 200) {
          this.permissionTree = res.data;
          this.permissionTreeSelect = [
            {
              id: 0,
              value: 0,
              label: "根节点",
              children: JSON.parse(JSON.stringify(this.permissionTree))
            }
          ];
        }
      })
      .catch(error => {
        this.$Message.error(error);
      });
    getRoleList()
      .then(res => {
        if (res.status === 200) {
          this.roleList = res.data;
        }
      })
      .catch(error => {
        this.$Message.error(error);
      });
  },
  data() {
    return {
      btn_save: false,
      leftpanel: 0.3, // 左右的分配比例
      permissionTree: [], //权限树
      permissionTreeSelect: [], //下拉的权限

      v_catelog: false,
      formData: {
        name: "",
        fronturl: "",
        url: "",
        pid: 0,
        level: "function",
        roles: ""
      },
      roleList: [],
      roles: []
    };
  },
  methods: {
    fn_change_level(name) {
      if (name == "menu" || name == "function") this.v_catelog = true;
      else {
        this.v_catelog = false;
        this.formData.wfcatelogid = [];
      }
    },
    // 保存权限
    fn_save() {
      this.formData.roles = JSON.stringify(this.roles);
      this.formData.wfcatelogid = JSON.stringify(this.wfcatelogid);
      //console.log(this.formData);

      storePermission(this.formData)
        .then(res => {
          if (res.data.code === 200) {
            this.btn_save = false;
            this.$Notice.success({ title: "通知", desc: res.data.message });
          } else {
            this.$Notice.error({ title: "错误", desc: res.data.message });
          }
        })
        .catch(error => {
          this.$Message.error(error);
        });
    },
    add_permission() {
      this.btn_save = true;
      this.roles = [];
      this.formData.id = 0;
      this.formData.name = "";
      this.formData.url = "";
      this.formData.fronturl = "";
      this.formData.level = "function";
      this.formData.roles = "";
    },
    edit_permission(object) {
      // 点击权限节点，获取权限和对应的角色信息
      getPermissionById(object[0].id)
        .then(res => {
          if (res.status === 200) {
            this.btn_save = true;
            this.formData = res.data;

            if (
              this.formData.level == "menu" ||
              this.formData.level == "function"
            )
              this.v_catelog = true;
            else {
              this.v_catelog = false;
            }
            this.roles = [];

            this.formData.roles.forEach(element => {
              this.roles.push(element.id);
            });
          }
        })
        .catch(error => {
          this.$Message.error(error);
        });
    }
  },
  props: {
    nameRules: {
      type: Array,
      default: () => {
        return [{ required: true, message: "名称不能为空", trigger: "blur" }];
      }
    },
    urlRules: {
      type: Array,
      default: () => {
        return [{ required: true, message: "Url不能为空", trigger: "blur" }];
      }
    }
  },
  computed: {
    rules() {
      return {
        name: this.nameRules,
        url: this.urlRules
      };
    }
  }
};
</script>


<style>
.demo-split {
  height: 1000px;
  border: 1px solid #dcdee2;
}
.demo-split-pane {
  padding: 10px;
}
</style>
